const routeUsageInfo = [
  {
    path: '/usage',
    name: 'UsagePage',
    component: () => import('@/pages/usage/UsagePage'),
    meta: {
      layout: 'HomeLayout',
    },
  },
];

export default routeUsageInfo;
